import React from "react";
import PropTypes from "prop-types";
import { alpha, Button } from "@mui/material";
import { theme } from "../Theme/index";

function DraggableBox({ name, onClick }) {
  return (
    <Button
      onClick={() => onClick?.()}
      sx={{
        border: `1px solid ${theme.palette.primary.main}`,
        fontWeight: theme.typography.fontWeightBold,
        color: theme.palette.primary.main,
        backgroundColor: alpha(theme.palette.primary.main, 0.18),
        borderRadius: { xs: 20, sm: 25 },
        padding: { xs: "4px 10px", sm: "6px 14px", md: "6px 16px" },
        minHeight: { xs: 28, sm: 32, md: 36 },
        height: "auto",
        fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.875rem" },
        lineHeight: 1.3,
        textTransform: "none",
        whiteSpace: "normal",
        textAlign: "center",
        "&:hover": {
          backgroundColor: alpha(theme.palette.primary.main, 0.28),
        },
      }}
    >
      {name}
    </Button>
  );
}

DraggableBox.propTypes = {
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default DraggableBox;
